import usePortfolioSender from './usePortfolioSender';
import usePortfolioReceiver from './usePortfolioReceiver';

const useGenPortfolio = (allowUnsubscribe = true) => {
  usePortfolioSender(allowUnsubscribe);
  usePortfolioReceiver();
};

export default useGenPortfolio;
